import axios from 'axios';

const API_BASE = '/api/training-documents';
const COMPLETIONS_BASE = '/api/training-completions';

export const trainingService = {
  listDocuments: async () => {
    const response = await axios.get(API_BASE);
    return response.data;
  },

  getDocument: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  uploadDocument: async ({ file, title, description, assignmentMode, requiresSupervisorSignoff, effectiveDate }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    if (description) formData.append('description', description);
    if (effectiveDate) formData.append('effective_date', effectiveDate);
    formData.append('assignment_mode', assignmentMode || 'all_active');
    formData.append('requires_supervisor_signoff', requiresSupervisorSignoff !== false ? 'true' : 'false');
    const response = await axios.post(API_BASE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateDocument: async (id, body) => {
    const response = await axios.patch(`${API_BASE}/${id}`, body);
    return response.data;
  },

  replaceDocumentFile: async (id, { file, effectiveDate, requireResign }) => {
    const formData = new FormData();
    formData.append('file', file);
    if (effectiveDate) formData.append('effective_date', effectiveDate);
    formData.append('require_resign', requireResign ? 'true' : 'false');
    const response = await axios.put(`${API_BASE}/${id}/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteDocument: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  updateItems: async (id, items) => {
    const response = await axios.put(`${API_BASE}/${id}/items`, { items });
    return response.data;
  },

  updateFields: async (id, fields) => {
    const response = await axios.put(`${API_BASE}/${id}/fields`, { fields });
    return response.data;
  },

  updateTargets: async (id, targets) => {
    const response = await axios.put(`${API_BASE}/${id}/targets`, { targets });
    return response.data;
  },

  getCompletions: async (documentId) => {
    const response = await axios.get(`${API_BASE}/${documentId}/completions`);
    return response.data;
  },

  getDocumentDownloadUrl: (id) => `${API_BASE}/${id}/download`,

  listMine: async () => {
    const response = await axios.get(`${COMPLETIONS_BASE}/mine`);
    return response.data;
  },

  getCompletion: async (id) => {
    const response = await axios.get(`${COMPLETIONS_BASE}/${id}`);
    return response.data;
  },

  getCompletionDownloadUrl: (id) => `${COMPLETIONS_BASE}/${id}/download`,

  downloadCompletionPdf: async (id) => {
    const response = await axios.get(`${COMPLETIONS_BASE}/${id}/download`, { responseType: 'blob' });
    return response.data;
  },

  getCompletedDownloadUrl: (id) => `${COMPLETIONS_BASE}/${id}/completed-download`,

  downloadCompletedPdf: async (id) => {
    const response = await axios.get(`${COMPLETIONS_BASE}/${id}/completed-download`, { responseType: 'blob' });
    return response.data;
  },

  downloadDocumentPdf: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}/download`, { responseType: 'blob' });
    return response.data;
  },

  employeeSign: async (id, { signatureImage, signatureText, checkedItemIds, fieldCompletions }) => {
    const response = await axios.post(`${COMPLETIONS_BASE}/${id}/employee-sign`, {
      signatureImage,
      ...(signatureText ? { signatureText } : {}),
      checkedItemIds,
      ...(fieldCompletions ? { fieldCompletions } : {}),
    });
    return response.data;
  },

  listPendingSupervisor: async () => {
    const response = await axios.get(`${COMPLETIONS_BASE}/pending-supervisor`);
    return response.data;
  },

  supervisorSign: async (id, { signatureImage, signatureText, fieldCompletions }) => {
    const response = await axios.post(`${COMPLETIONS_BASE}/${id}/supervisor-sign`, {
      signatureImage,
      ...(signatureText ? { signatureText } : {}),
      ...(fieldCompletions ? { fieldCompletions } : {}),
    });
    return response.data;
  },

  getSignatureImageUrl: (completionId, which = 'employee') =>
    `${COMPLETIONS_BASE}/${completionId}/signature-image?which=${which}`,

  getFieldSignatureImageUrl: (completionId, fieldId) =>
    `${COMPLETIONS_BASE}/${completionId}/field-signature-image?fieldId=${fieldId}`,
};
